/**
 * 用户相关业务路由
 */
export default {
  path: '/user',
  component: () => import('@/views/User/index'),
  meta: {requireAuth: true},
  children: [
    {
      path: '',
      component: () => import('@/views/User/Home'),
      name: 'user'
    },
    {
      path: 'saleUser',
      component: () => import('@/views/User/sales-home'),
      name: 'sale_user'
    },
    {
      path: 'order',
      component: () => import('@/views/User/Order'),
      name: 'user_order'
    },
    {
      path: 'discounts',
      component: () => import('@/views/User/discounts'),
      name: 'user_discounts'
    },
    {
      path: 'message',
      component: () => import('@/views/User/Message'),
      name: 'user_message'
    },
    {
      path: 'messages',
      component: () => import('@/views/User/Messages'),
      children: [
        {
          path: 'comments',
          component: () => import('@/views/User/messages-comments'),
          name: 'messages_comments'
        },
        {
          path: 'thumb',
          component: () => import('@/views/User/messages-thumb'),
          name: 'messages_thumb'
        },
        {
          path: 'notice',
          component: () => import('@/views/User/messages-notice'),
          name: 'messages_notice'
        }
      ]
    },
    {
      path: 'feed',
      component: () => import('@/views/User/feed'),
      name: 'user_feed'
    },
    {
      path: 'fans',
      component: () => import('@/views/User/fans'),
      name: 'user_fans'
    },
    {
      path: 'follow',
      component: () => import('@/views/User/follow'),
      name: 'user_follow'
    },
    {
      path: 'faq',
      component: () => import('@/views/User/faq'),
      name: 'user_faq'
    },
    {
      path: 'faq_answer',
      component: () => import('@/views/User/faq-answer'),
      name: 'user_faq_answer'
    },
    {
      path: 'faq_follow',
      component: () => import('@/views/User/faq-follow'),
      name: 'user_faq_follow'
    },
    {
      path: 'setting',
      component: () => import('@/views/User/Setting'),
      name: 'user_setting'
    },
    {
      path: 'setting/password',
      component: () => import('@/views/User/password'),
      name: 'setting_password'
    },
    {
      path: 'setting/bind-tel',
      component: () => import('@/views/User/bind-tel'),
      name: 'bind_tel'
    },
    {
      path: 'setting/edit-tel',
      component: () => import('@/views/User/edit-tel'),
      name: 'edit_tel'
    },
    {
      path: 'setting/car-certify',
      component: () => import('@/views/User/car-certify'),
      name: 'car_certify'
    },
    {
      path: 'camp',
      component: () => import('@/views/User/camp'),
      name: 'user_camp'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/user.js